<template>
  <b-card>
    <b-row class="mb-2">
      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('general.room_counts')">
          <v-select
            v-model="room_count"
            :options="['все', 1, 2, 3, 4]"
            :reduce="(user) => user"
            class="bg-white"
            @input="sendData"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <div style="overflow-x: auto">
      <table class="table">
        <thead class="center-th">
          <tr>
            <th rowspan="3">{{ $t("general.object_name") }}</th>
            <th colspan="12">{{ $t("general.unsolder_flat") }}</th>
          </tr>
          <tr>
            <th scope="col" colspan="3">{{ $t("general.last") }}</th>
            <th scope="col" colspan="3">{{ $t("general.occupied") }}</th>
            <th scope="col" colspan="3">{{ $t("general.busy") }}</th>
            <th scope="col" colspan="3">{{ $t("general.free") }}</th>
          </tr>
          <tr>
            <th scope="col">{{ $t("general.numbers_room") }}</th>
            <th scope="col">м2</th>
            <th scope="col">{{ $t("general.price") }}</th>
            <th scope="col">{{ $t("general.numbers_room") }}</th>
            <th scope="col">м2</th>
            <th scope="col">{{ $t("general.price") }}</th>
            <th scope="col">{{ $t("general.numbers_room") }}</th>
            <th scope="col">м2</th>
            <th scope="col">{{ $t("general.price") }}</th>
            <th scope="col">{{ $t("general.numbers_room") }}</th>
            <th scope="col">м2</th>
            <th scope="col">{{ $t("general.price") }}</th>
          </tr>
        </thead>
        <tbody class="center-td">
          <tr v-for="item in GET_NOT_SOLD_FLAT" :key="item.id">
            <td>{{ item.title }}</td>
            <td>{{ item.total_flat_count }}</td>
            <td>{{ item.total_flat_area }}</td>
            <td>{{ $_moneyFormatter(item.total_flat_amount) }}</td>
            <td>{{ item.total_management_bron_flat_count }}</td>
            <td>{{ item.total_management_bron_flat_area }}</td>
            <td>
              {{ $_moneyFormatter(item.total_management_bron_flat_amount) }}
            </td>
            <td>{{ item.total_occupied_flat_count }}</td>
            <td>{{ item.total_occupied_flat_area }}</td>
            <td>{{ $_moneyFormatter(item.total_occupied_flat_amount) }}</td>
            <td>{{ item.total_available_flat_count }}</td>
            <td>{{ item.total_available_flat_area }}</td>
            <td>{{ $_moneyFormatter(item.total_available_flat_amount) }}</td>
          </tr>
          <tr style="background-color: #f3f2f7">
            <td>
              {{ $t('general.last') }}
            </td>
            <td>{{ totalFlatCount }}</td>
            <td>{{ totalFlatArea }}</td>
            <td>{{ $_moneyFormatter(totalFlatAmount) }}</td>
            <td>{{ totalManagementBronFlatCount }}</td>
            <td>{{ totalManagementBronFlatArea }}</td>
            <td>{{ $_moneyFormatter(totalManagementBronFlatAmount) }}</td>
            <td>{{ totalOccupiedFlatCount }}</td>
            <td>{{ totalOccupiedFlatArea }}</td>
            <td>{{ $_moneyFormatter(totalOccupiedFlatAmount) }}</td>
            <td>{{ totalAvailableFlatCount }}</td>
            <td>{{ totalAvailableFlatArea }}</td>
            <td>{{ $_moneyFormatter(totalAvailableFlatAmount) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  BCard,
  BSpinner,
  BTr,
  BTh,
  BTable,
  BRow,
  BCol,
  BFormGroup,
} from "bootstrap-vue";
import formatters from "@/mixins/extra";
import VSelect from "vue-select";
export default {
  components: {
    BCard,
    BFormGroup,
    BTable,
    VSelect,
    BSpinner,
    BRow,
    BCol,
    BTr,
    BTh,
  },
  mixins: [formatters],

  data() {
    return {
      loader: false,
      room_count: null,
      fields: [
        {
          key: "id",
          label: "ID",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "title",
          label: "Obyekt nomi",
        },
        {
          key: "total_flat_count",
          label: "Soni",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_flat_area",
          label: "m2",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sold_flat_count",
          label: "Soni",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sold_flat_area",
          label: "m2",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("objects", ["GET_REPORTS_TABLE", "GET_NOT_SOLD_FLAT"]),
    totalAvailableFlatAmount() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_available_flat_amount;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalAvailableFlatArea() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_available_flat_area;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalAvailableFlatCount() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_available_flat_count;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalOccupiedFlatAmount() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_occupied_flat_amount;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalOccupiedFlatArea() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_occupied_flat_area;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalOccupiedFlatCount() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_occupied_flat_count;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalManagementBronFlatAmount() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_management_bron_flat_amount;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalManagementBronFlatArea() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_management_bron_flat_area;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalManagementBronFlatCount() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_management_bron_flat_count;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalFlatAmount() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_flat_amount;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalFlatArea() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_flat_area;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalFlatCount() {
      let data = this.GET_NOT_SOLD_FLAT.map((item) => {
        return item.total_flat_count;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
  },

  mounted() {
    this.FETCH_NOT_SOLD_FLAT();
    // this.FETCH_REPORTS_TABLE().then(() => {
    //   this.loader = false;
    // });
  },

  methods: {
    ...mapActions("objects", ["FETCH_REPORTS_TABLE", "FETCH_NOT_SOLD_FLAT"]),
    sendData(val) {
      console.log(val);
      if (val == "все") {
        this.FETCH_NOT_SOLD_FLAT();
      } else {
        this.FETCH_NOT_SOLD_FLAT({ rooms_count: val });
      }
    },
  },
};
</script>

<style>
table,
th,
th {
  border: 1px solid #ccc !important;
}
.bg-warning {
  background: #fefe00 !important;
}

table {
  border: 0px solid red !important;
}

td {
  white-space: nowrap;
}

.text-center {
  text-align: center !important;
}

.center-th th {
  vertical-align: middle !important;
  text-align: center !important;
}
.center-td td {
  vertical-align: middle !important;
  text-align: center !important;
}
</style>
